// ##################################################
// Load videos on first scroll
// ##################################################

const videos = document.querySelectorAll('.playMeOnScroll');
const loadVideosOnScroll = () => {
  const videoLazyLoaded = document.body.classList.contains('videos-loaded');
  if (!videoLazyLoaded) {
    videos.forEach((video) => {
      if(!(document.querySelector('video').playing)){
        console.log('video is not playing');
        video.play();
      }
    });
    document.body.classList.add('videos-loaded');
  }
};

window.addEventListener(
  'scroll',
  () => {
    loadVideosOnScroll();
  },
  false,
);
